import React from 'react';

const ColoresDeckTablonWpc = () => {
  const colores = [
    { nombre: 'Nogal', img: '/assets/img/productos/piso-deck-wpc/color-nogal.png' },
    { nombre: 'Gris', img: '/assets/img/productos/piso-deck-wpc/color-gris.png' },
    { nombre: 'Roble', img: '/assets/img/productos/piso-deck-wpc/color-roble.png' },
    { nombre: 'Café', img: '/assets/img/productos/piso-deck-wpc/color-cafe.png' }
  ];

  return (
    <section>
      <div className="container">
        <div className="section-heading text-center mb-5">
          <h2 className="h1 font-weight-800">Colores Disponibles</h2>
          <p className="w-md-75 w-lg-60 mx-auto">
            Elige el tono perfecto para armonizar con tu espacio exterior.
          </p>
        </div>
        <div className="row justify-content-center">
          {colores.map((color, index) => (
            <div key={index} className="col-md-6 col-lg-3 mb-4 mb-lg-0">
              <div className="card border-0 shadow-sm h-100 text-center hover-top-small transition-all">
                <div className="card-img-top overflow-hidden position-relative" style={{height: '200px'}}>
                  <img 
                    src={color.img} 
                    alt={`Deck color ${color.nombre}`} 
                    className="w-100 h-100 object-fit-cover"
                    style={{objectFit: 'cover'}}
                  />
                </div>
                <div className="card-body py-4">
                  <h5 className="card-title mb-0 font-weight-700">{color.nombre}</h5>
                  {/* Si tienes códigos de color específicos, puedes agregarlos aquí */}
                  {/* <small className="text-muted">Código: {color.codigo}</small> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ColoresDeckTablonWpc;